import React, { useState } from 'react';
import { Form, Input, Button, message } from 'antd';
import { Popover } from '../../popup/popup';
import FeatherIcon from 'feather-icons-react';
import { Link } from 'react-router-dom';
import { updateUserPassword } from '../../../redux/common/actionCreator';
import { useDispatch, useSelector } from 'react-redux';
import { logOut } from '../../../redux/authentication/actionCreator';

const SifreGuncelle = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const email = useSelector(s => s.users?.user?.email ?? '');
  const [passwordChecks, setPasswordChecks] = useState(
    validatePasswordPolicy('')
  );
  function validatePasswordPolicy(pwd) {
    return [
      { label: 'En az 12 karakter olmalı.', valid: pwd?.length >= 12 },
      {
        label: 'En az bir büyük harf içermeli (A–Z).',
        valid: /[A-Z]/.test(pwd),
      },
      {
        label: 'En az bir küçük harf içermeli (a–z).',
        valid: /[a-z]/.test(pwd),
      },
      { label: 'En az bir rakam içermeli (0–9).', valid: /\d/.test(pwd) },
      {
        label: 'En az bir özel karakter içermeli (örn. !@#$%^&*).',
        valid: /[^A-Za-z0-9]/.test(pwd),
      },
    ];
  }
  const onFinish = async values => {
    let result = await dispatch(
      updateUserPassword({
        email: email,
        currentPassword: values.currentPassword,
        newPassword: values.newPassword,
        newPasswordAgain: values.newPasswordAgain,
      })
    );

    if (result.status === 200) {
      message.success('Kullanıcı bilgileri güncellendi!');
      setTimeout(() => {
        setLoading(false);
        dispatch(logOut());
      }, 2000);
    } else {
      message.warning(result.statusText);
    }
  };

  const onFinishFailed = errorInfo => {
    message.error('Lütfen Formu Doldurunuz.');
  };

  const content = (
    <Form
      form={form}
      name="update_user"
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      labelCol={{ span: 8 }}
      wrapperCol={{ span: 16 }}
      autoComplete="off"
      style={{ maxWidth: '400px', margin: '0 auto' }}
    >
      <Form.Item
        label="Mevcut Şifre"
        name="currentPassword"
        rules={[{ required: true, message: 'Mevcut Şifre zorunlu alan' }]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item
        label="Yeni Şifre"
        name="newPassword"
        rules={[{ required: true, message: 'Yeni Şifre zorunlu alan' }]}
      >
        <Input.Password
          onChange={e =>
            setPasswordChecks(validatePasswordPolicy(e.target.value))
          }
        />
      </Form.Item>
      <div style={{ marginTop: -8, marginBottom: 16, fontSize: 13 }}>
        {passwordChecks.map(check => (
          <div
            key={check.label}
            style={{ color: check.valid ? 'green' : 'red' }}
          >
            {check.valid ? '✔' : '✖'} {check.label}
          </div>
        ))}
      </div>
      <Form.Item
        label="Şifre Tekrar"
        name="newPasswordAgain"
        dependencies={['newPassword']}
        rules={[
          { required: true, message: 'Yeni Şifre (Tekrar) zorunlu alan' },
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('newPassword') === value)
                return Promise.resolve();
              return Promise.reject(new Error('Şifreler uyuşmuyor'));
            },
          }),
        ]}
      >
        <Input.Password />
      </Form.Item>

      <Form.Item wrapperCol={{ offset: 8, span: 16 }}>
        <Button type="primary" htmlType="submit" loading={loading}>
          Güncelle
        </Button>
      </Form.Item>
    </Form>
  );

  return (
    <div className="notification">
      <Popover placement="leftBottom" content={content} action="click">
        <Link to="#" className="head-example">
          <FeatherIcon icon="lock" size={20} /> Şifre İşlemleri
        </Link>
      </Popover>
    </div>
  );
};

export default SifreGuncelle;
